import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import VerificaToken from "./VerificaToken";

function RimozionePagamento() {
  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);
  let history = useHistory();

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const elimina = () => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/rimuoviPagamento`
      )
      .then((response) => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setShow(false);
            setUser(res.data);
            history.go(0);
          });
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };

  if (user.codiceCarta) {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-wallet-fill"
            viewBox="0 0 16 16"
          >
            <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z" />
          </svg>
          <h3>Rimuovi Metodo di Pagamento</h3>
          <p>
            Clicca qui per rimuovere un metodo di pagamento inserito
            precedentemente.
          </p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Rimozione Pagamento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di volere rimuovere il tuo metodo di pagamento?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Torna Indietro
            </Button>
            <Button variant="primary" onClick={elimina}>
              Sono Sicuro
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-wallet-fill"
            viewBox="0 0 16 16"
          >
            <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z" />
          </svg>
          <h3>Rimuovi Metodo di Pagamento</h3>
          <p>
            Clicca qui per rimuovere un metodo di pagamento inserito
            precedentemente.
          </p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Rimozione Pagamento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Non hai inserito alcun metodo di pagamento, vuoi inserine uno ora?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No grazie.
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                history.push(`/account/info/${user.id}/aggiungiPagamento`);
              }}
            >
              Va bene!
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default RimozionePagamento;
